import { render, staticRenderFns } from "./gender-female.vue?vue&type=template&id=540ac472&scoped=true"
var script = {}
import style0 from "./gender-female.vue?vue&type=style&index=0&id=540ac472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540ac472",
  null
  
)

export default component.exports